import { createHelpers } from 'vuex-map-fields';

const { getPosStateField, updatePosStateField } = createHelpers({
    getterType: `getPosStateField`,
    mutationType: `updatePosStateField`,
});


const state = {
    can_close_modal : true,
    is_load : false,
    is_load_complete : false,
    pos_item : {
        is_init : false,
        provider : {
            id : 0,
            human_name : "",
        },
        params_type : {

        },

        pos_params : {
            id : 0,
        },
        basic_params : {
            id : 0,
        },
    },
};

// actions
const actions = {
    LOAD_PROVIDER({commit},pos_id) {
        commit('set_load',true);
        commit('set_load_complete',false);

        pos_api.get('/pos/' + pos_id).then(({data}) => {
            if(data.status === 'operation_success') {
                commit('set_pos', data.data);
            }
        }).catch(({response}) => {
            commit('set_load',false);
            EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
            console.log(response);
        });
    },

    SET_LOAD_COMPLETE({commit},flag) {
        commit('set_load',!flag);
        commit('set_load_complete',flag);
    },
};

// mutations
const mutations = {
    core_const (state, data) {
        state.core_const = {...state.core_const, ...data}
    },

    set_pos (state,data) {
        state.pos_item = {...state.pos_item, ...data}
        state.is_load = false;
        state.is_load_complete = true;
        EventBus.$emit('load_pos_provider',state.pos_item);
    },

    set_load(state,is_load) {
        state.is_load = is_load;
    },

    set_load_complete(state,is_load) {
        state.is_load_complete = is_load;
    },
};

const getters = {
    getPos(state) {
        return state.pos_item;
    },

    is_load(state) {
        return state.is_load;
    },

    is_load_complete(state) {
        return state.is_load_complete;
    },

    getPosStateField,

};


export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
}
